import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Spinner } from '@ps-design-system/components/Spinner';

import { usePauseModal } from '../context/PauseModalContext';

const PauseModalTitle = ({ isToggled, isPaused }) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const { listingType } = usePauseModal();

  useEffect(() => {
    setShowSpinner(true);

    const timer = setTimeout(() => {
      setShowSpinner(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [isToggled]);

  if (showSpinner) {
    return (
      <div className='pause-spinner'><Spinner appearance="black" /></div>
    );
  }

  const title = isPaused
    ? <FormattedMessage id="pause.modal.confirm_pause" defaultMessage="Are you sure you want to pause your"/>
    : <FormattedMessage id="pause.modal.confirm_activate" defaultMessage="Are you sure you want to activate your"/>

  if (isToggled) {
    return (
      <div className="pause-title">
        <Text typeface="body-2" >
          {title}
        </Text>
        {' '}
        <Text typeface="body-2" >
          <FormattedMessage id="pause.modal.listings" defaultMessage="listings?"/>
        </Text>
      </div>
    );
  }
  return (
    <div className="pause-title">
      <Text typeface="body-2" >
        {title}
      </Text>
      {' '}
      <Text typeface="body-2-m" >
        <FormattedMessage {...listingType}/>
      </Text>
      {' '}
      <Text typeface="body-2" >
        <FormattedMessage id="pause.modal.activate_listing" defaultMessage="listing?"/>
      </Text>
    </div>
  );
};

PauseModalTitle.propTypes = {
  isToggled: PropTypes.bool,
  isPaused: PropTypes.bool
};

PauseModalTitle.defaultProps = {
  isToggled: false,
  isPaused: false
};

export default PauseModalTitle;
